import { useDevelopmentPlanQuery } from '@treams/treams-network';

import DevelopmentPlan from '../../development-plan/components/DevelopmentPlan';
import Goals from '../../development-plan/components/Goals';

export default function EvaluationSubmissionItemDevelopmentPlan({ userID }: { userID: string }) {
	const query = useDevelopmentPlanQuery({
		variables: { userID },
	});

	return (
		<>
			{query.loading && <DevelopmentPlan.Skeleton />}
			{query.data?.user && (
				<Goals
					onSave={() => {
						query.refetch();
					}}
					user={query.data.user}
				/>
			)}
		</>
	);
}
